<template>
    <article class="brand-page">
        <BrandBanner
            :background-src="banner.backgroundSrc"
            :background-alt="banner.backgroundAlt || `${info.brandName || ''} background`"
            :logo-src="banner.logoSrc"
            :logo-alt="banner.logoAlt || `${info.brandName || ''} logo`"
            :logo-class="banner.logoClass || ''"
            :overlay-color="banner.overlayColor || 'black'"
            :overlay-opacity="typeof banner.overlayOpacity === 'number' ? banner.overlayOpacity : 0.75"
        />
        <BrandInfo
            :brand-name="info.brandName || ''"
            :phone="info.phone || ''"
            :phone-href="info.phoneHref || ''"
            :email="info.email || ''"
            :contact-info-label="labels.contactInfo"
            :follow-label="labels.follow"
            :socials="info.socials || []"
            :amazon-url="info.amazonUrl || ''"
        >
            <p v-for="(paragraph, index) in body" :key="index">{{ paragraph }}</p>
            <div v-if="cta.href" class="buttons-container">
                <slot name="buttons">
                    <a
                        class="btn btn-primary btn-revamp"
                        :href="cta.href"
                        target="_blank"
                        rel="noopener noreferrer"
                    >{{ cta.label || cta.href.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '') }}</a>
                </slot>
            </div>
        </BrandInfo>
        <BrandProducts :heading="products.heading || ''" :products="products.items || []" />
    </article>
</template>

<script>
import BrandBanner from "./sections/BrandBanner.vue";
import BrandInfo from "./sections/BrandInfo.vue";
import BrandProducts from "./sections/BrandProducts.vue";

export default {
    name: "BrandPage",
    components: {
        BrandBanner,
        BrandInfo,
        BrandProducts,
    },
    props: {
        content: { type: Object, required: true },
    },
    computed: {
        banner() {
            return this.content.banner || {};
        },
        info() {
            return this.content.info || {};
        },
        labels() {
            const labels = this.info.labels || {};

            return {
                contactInfo: labels.contactInfo || this.info.contactInfoLabel || "",
                follow: labels.follow || this.info.followLabel || "",
            };
        },
        cta() {
            const cta = this.info.cta || {};

            return {
                href: cta.href || this.info.websiteUrl || "",
                label: cta.label || this.info.websiteLabel || "",
            };
        },
        products() {
            return this.content.products || {};
        },
        body() {
            return Array.isArray(this.content.body) ? this.content.body : [];
        },
    },
};
</script>

<style scoped lang="scss">
.brand-page {
    .buttons-container {
        margin-top: 2rem;
    }

    .btn-revamp {
        border-radius: 16px !important;
        line-height: 1 !important;
        padding: 0.5rem 0.75rem !important;
    }
}
</style>
